import { Container, Row, Col, Tab, Nav, Badge } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";

import payplusImage from "../assets/img/project-img-payplus.png";
import jaygaImage from "../assets/img/project-img-jayga.png";
import myzooImage from "../assets/img/project-img-myzoo.png";
import salebeeImage from "../assets/img/project-img-salebee.png";
import holytuneImage from "../assets/img/project-img-holytune.png";
import hisabeeImage from "../assets/img/project-img-hisabee.png";
import braintdoadsImage from "../assets/img/braintodoads.png";

import "animate.css";
import "./css/Project.css";
import "./css/experience.css";

import TrackVisibility from "react-on-screen";

export const Projects = () => {
  const experiences = [
        {
      company: "Pay Station",
      role: "Lead Flutter Developer",
      details:
        "Built PayPlus Agent end-to-end; high-volume fintech in production. A well known local startup. Led Flutter development, API design, and release management for a high-transaction fintech app.",
      time: "Feb 2023 – Present",
      impact: ["Huge Transaction Volume", "Zero-downtime releases", "Secure flows"],
    },
        {
      company: "SaleBee",
      role: "Mobile Lead • BASIS ICT Winner ’23",
      details:
        "Sole developer on SaleBee CRM app; project won BASIS ICT Award 2023. Focused on robust offline sync and usability.",
      time: "May 2022 – Jan 2023",
      impact: ["BASIS ICT Award", "Offline-first CRM", "Scalable API use"],
    },
        {
      company: "Hishabee",
      role: "Mobile Lead",
      details:
        "Hishabe is a well known startup in Bangladesh. Led mobile development; stabilized releases and improved runtime performance.",
      time: "Jan 2022 – Apr 2022",
      impact: ["Release cadence", "Crash analytics", "Growth support"],
    },
        {
      company: "Advanced App Bangladesh",
      role: "Senior Flutter Developer",
      details:
        "Worked across multiple client apps; leveled up code reviews and CI discipline. Worked with foreign clients on diverse projects, improving code quality and release processes across the board.",
      time: "Jun 2020 – Dec 2021",
      impact: ["Multi-app delivery", "Widget hygiene", "CI/CD adoption"],
    },
    {
      company: "Right Brain Solution",
      role: "Laravel → Flutter Trajectory",
      details:
        "Started as Laravel dev; picked up Flutter and shipped first cross-platform apps.",
      time: "Apr 2019 – May 2020",
      impact: ["API foundations", "First prod apps", "Release pipeline basics"],
    },




  ];

  const projects = [
    {
      title: "PayPlus Agent",
      description:
        "High-volume fintech app handling ৳60–70 lakh/day. Architected and developed solo (Flutter, secure APIs, release ops).",
      imgUrl: payplusImage,
      link: "https://play.google.com/store/search?q=payplus+agent&c=apps",
      tags: ["Fintech", "Flutter", "Prod Scale"],
    },
    {
      title: "HolyTune",
      description:
        "Bangladesh’s first commercial Islamic music app. Hit 100k downloads in the first month.",
      imgUrl: holytuneImage,
      link: "https://play.google.com/store/apps/details?id=com.v4technologiesbd.holy_tune",
      tags: ["Media", "Growth 100k+", "Play Store"],
    },
    {
      title: "SaleBee",
      description:
        "Award-winning CRM (BASIS ICT ’23). SaleBee CRM app developed solely by me; focused on robust offline sync and usability.",
      imgUrl: salebeeImage,
      link: "https://play.google.com/store/apps/details?id=com.salebee.crm",
      tags: ["CRM", "Award", "Offline-first"],
    },
    {
      title: "Hishabee",
      description:
        "Contributed to core mobile app; stabilized releases and improved runtime performance.",
      imgUrl: hisabeeImage,
      link: "https://play.google.com/store/apps/details?id=com.hishabee.business",
      tags: ["Startup", "Performance"],
    },
    {
      title: "MyZoo",
      description:
        "Large multivendor e-commerce suite. Built three apps (User, Merchant, Delivery) and led backend APIs.",
      imgUrl: myzooImage,
      link: "https://play.google.com/store/apps/details?id=com.myzoo.customer",
      tags: ["E-commerce", "3 Apps", "Backend APIs"],
    },
    {
      title: "Jayga",
      description:
        "Lead developer across the stack: Android/iOS, DB modeling, API development, and targeted backend modifications.",
      imgUrl: jaygaImage,
      link: "https://play.google.com/store/apps/details?id=com.jayga.app",
      tags: ["Full-stack", "Architecture", "Ops"],
    },
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <h2 className="title-label">Projects & Experience</h2>

                  {/* Experience Timeline */}
                  <div className="experience-timeline">
                    {experiences.map((exp, idx) => (
                      <div className="exp-card" key={idx}>
                        <div className="exp-left">
                          <div className="exp-dot" />
                          <div className="exp-rail" />
                        </div>
                        <div className="exp-body">
                          <div className="exp-header">
                            <h3 className="exp-company">{exp.company}</h3>
                            <span className="exp-time">{exp.time}</span>
                          </div>
                          <div className="exp-role">{exp.role}</div>
                          <p className="exp-details">{exp.details}</p>
                          {exp.impact?.length > 0 && (
                            <div className="exp-tags">
                              {exp.impact.map((t) => (
                                <Badge bg="secondary" key={t} className="exp-badge">
                                  {t}
                                </Badge>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Projects */}
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Nav
                      variant="pills"
                      className="nav-pills mb-5 justify-content-center align-items-center"
                      id="pills-tab"
                    >
                      <Nav.Item>
                        <Nav.Link eventKey="first">Top Projects</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second">Mentioned Projects</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="third">Contributions</Nav.Link>
                      </Nav.Item>
                    </Nav>

                    <Tab.Content
                      id="slideInUp"
                      className={isVisible ? "animate__animated animate__slideInUp" : ""}
                    >
<Tab.Pane eventKey="first"> <Row> { projects.map((project, index) => { return ( <ProjectCard key={index} {...project} /> ) }) } </Row> </Tab.Pane>

                      {/* Keep a slot for more later */}
                      <Tab.Pane eventKey="second">
                        <p className="muted">
                          Hand-picked additional work—integrations, internal tools, and experiments that shaped my process.
                        </p>
                      </Tab.Pane>

                      <Tab.Pane eventKey="third">
                        <p className="muted">
                          Open-source fixes, performance tickets, and cross-team reviews that kept products healthy.
                        </p>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>

                   <img src={braintdoadsImage}/>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
